import { IApplicationState } from '../../types/redux';

/**
 * Выбирает все галереи Было-Стало
 */
export const selectPostContentBeforeAfterGalleries = ({ postContentBeforeAfterGalleries }: IApplicationState) =>
  postContentBeforeAfterGalleries.items;
